import { GET_ALL_ADS } from "./actions";

const initialState = {
  adsList: [],

  loading: true,
};

const adsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_ALL_ADS:
      return {
        ...state,
        loading: false,
        adsList: payload,
      };

    default:
      return state;
  }
};

export default adsReducer;
